<template>
  <div id="search-page" class="bg-gray-20">
    <product-list class="pb-6 md:pb-10" />
  </div>
</template>

<script setup lang="ts">
import ProductList from '@/components/product/product-list.vue'

definePageMeta({
  middleware: ['check-region'],
})
</script>

<style lang="scss" scoped>
#search-page {
  min-height: var(--content-min-height);
}
</style>
